import { configureStore } from '@reduxjs/toolkit';
import { Reducer, combineReducers } from '@reduxjs/toolkit';
import { rootActions } from './rootActions';
import { appReducers } from './appReducers';
import { baseAppApi } from '@/core/network/baseAppApi';

const combinedReducers = combineReducers<typeof appReducers>(appReducers);

const rootReducer: Reducer<RootStateType> = (state, action) => {
  if (rootActions.resetStore.match(action)) {
    state = {} as RootStateType;
  }

  return combinedReducers(state, action);
};

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(baseAppApi.middleware),
});

export type RootStateType = ReturnType<typeof combinedReducers>;
export default store;
